import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const RefundPolicy: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white pt-28">
            <div className="max-w-4xl mx-auto px-6 md:px-8 py-16">
                {/* Back Link */}
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-[#009B8F] hover:text-[#007d72] transition-colors mb-8 font-medium"
                >
                    <ArrowLeft size={18} />
                    Back to Home
                </Link>

                {/* Header */}
                <div className="mb-12">
                    <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#00151a] mb-4">
                        Refund Policy
                    </h1>
                    <p className="text-slate-500 text-sm">Last updated: 1st March 2026</p>
                </div>

                {/* Content */}
                <div className="prose prose-slate max-w-none">
                    <div className="space-y-6 text-slate-700 leading-relaxed">
                        <p>
                            This Refund Policy explains when refunds may be offered for services provided by Nex Overseas Ltd. Our services include education consultancy, coaching and training, accommodation support, travel assistance, and a solicitor‑connection service for immigration or legal matters. Only the initial consultation is free. All other services are paid and delivered digitally.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Refund Eligibility</h2>
                        <p>
                            Refunds are only available in exceptional circumstances. A refund may be requested within 7 days of purchase, including weekends. After 7 days, we cannot offer a refund under any circumstances. Refunds are only granted if the issue is caused by us, such as a login error, technical problem, or system failure that prevents you from accessing the service you paid for. To qualify for a refund, you must provide reasonable evidence of the issue.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">When Refunds Are Not Available</h2>
                        <p>
                            We do not offer refunds for reasons such as a change of mind, dissatisfaction with the service, or comparing our services with other organisations or websites. We also do not offer refunds if you decide not to continue after accessing the service, or if you find alternative information or pricing elsewhere. Once a service has been accessed, used, or delivered — including consultations, coaching sessions, guidance, or solicitor‑connection services — the purchase becomes strictly non‑refundable.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">Payment Processing</h2>
                        <p>
                            Payments are processed securely through trusted third‑party providers such as Stripe or PayPal. Any refund approved by us will be returned to the original payment method. Processing times may vary depending on your bank or payment provider.
                        </p>

                        <h2 className="text-2xl font-serif font-bold text-[#00151a] mt-10 mb-4">How to Request a Refund</h2>
                        <p>
                            If you believe you qualify for a refund due to a technical issue on our side, you can contact us at <a href="mailto:info@nexoverseas.co.uk" className="text-[#009B8F] hover:underline">info@nexoverseas.co.uk</a> within the 7‑day window. We will review your request and respond as soon as possible. By purchasing our services, you agree to this Refund Policy.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;
